import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from 'components/ui';

type AuthFormHeaderBrandLockupProps = {
  hasCobranding?: boolean;
  isTextBranding?: boolean;
};

type AuthFormHeaderFirmLogoProps = {
  isTextBranding?: boolean;
};

export const AuthFormHeaderRoot = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(5),
  width: '100%',
}));

export const AuthFormHeaderBrandLockup = styled(Box, {
  shouldForwardProp: prop => prop !== 'hasCobranding' && prop !== 'isTextBranding',
})<AuthFormHeaderBrandLockupProps>(({ theme, hasCobranding }) => {
  let justifyContent = 'flex-start';

  if (hasCobranding) {
    justifyContent = 'flex-start';
  }

  return {
    alignItems: 'center',
    display: 'flex',
    gap: '10px',
    justifyContent,
    minHeight: 40,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: hasCobranding ? 'column' : 'row',
      gap: theme.spacing(0.5),
      justifyContent: 'center',
    },
  };
});

export const AuthFormHeaderBrandLink = styled(RouterLink)({
  alignItems: 'center',
  display: 'inline-flex',
  lineHeight: 0,
  textDecoration: 'none',
});

export const AuthFormHeaderMarkLogo = styled('img')({
  alignSelf: 'center',
  display: 'block',
  height: 'auto',
  maxHeight: 34,
  maxWidth: 112,
  objectFit: 'contain',
  width: 112,
});

export const AuthFormHeaderPlus = styled('span')(({ theme }) => ({
  alignSelf: 'center',
  alignItems: 'center',
  color: theme.palette.text.disabled,
  display: 'inline-flex',
  fontSize: 48,
  fontWeight: 400,
  justifyContent: 'center',
  lineHeight: 1.2,
  [theme.breakpoints.down('sm')]: {
    fontSize: 36,
  },
}));

export const AuthFormHeaderFirmLogo = styled(Box, {
  shouldForwardProp: prop => prop !== 'isTextBranding',
})<AuthFormHeaderFirmLogoProps>(({ theme, isTextBranding }) => ({
  alignSelf: 'center',
  alignItems: 'center',
  display: 'flex',
  flex: isTextBranding ? '0 1 auto' : '0 0 auto',
  gap: theme.spacing(1.5),
  justifyContent: isTextBranding ? 'flex-start' : 'center',
  maxWidth: '100%',
  minHeight: 34,
  minWidth: 0,
  width: isTextBranding ? 'min(100%, 420px)' : 'auto',
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
    width: '100%',
  },
}));

export const AuthFormHeaderFirmImage = styled('img')({
  display: 'block',
  height: 'auto',
  maxHeight: 34,
  maxWidth: 'min(100%, 180px)',
  objectFit: 'contain',
  width: 'auto',
});

export const AuthFormHeaderFirmIcon = styled('img')({
  display: 'block',
  height: 34,
  maxHeight: 34,
  maxWidth: 34,
  objectFit: 'contain',
  width: 34,
});

export const AuthFormHeaderFirmName = styled('span')(({ theme }) => ({
  alignItems: 'center',
  color: theme.palette.text.primary,
  display: 'inline-flex',
  fontSize: 20,
  fontWeight: 700,
  justifyContent: 'flex-start',
  lineHeight: 1.2,
  maxWidth: '100%',
  overflowWrap: 'anywhere',
  textAlign: 'left',
  width: 'auto',
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    justifyContent: 'center',
    textAlign: 'center',
    width: '100%',
  },
}));

interface AuthFormHeaderSubtitleProps {
  subtitleVariant?: 'default' | 'lead';
}

export const AuthFormHeaderSubtitle = styled('p', {
  shouldForwardProp: prop => prop !== 'subtitleVariant',
})<AuthFormHeaderSubtitleProps>(({ theme, subtitleVariant = 'default' }) => ({
  color: subtitleVariant === 'lead' ? theme.palette.text.primary : theme.palette.text.secondary,
  fontSize: subtitleVariant === 'lead' ? 18 : 16,
  fontWeight: subtitleVariant === 'lead' ? 500 : 400,
  lineHeight: subtitleVariant === 'lead' ? 1.4 : 1.55,
  margin: 0,
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));

export const AuthFormHeaderTitle = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.down('sm')]: {
    textAlign: 'center',
  },
}));
